import React from 'react';
import classnames from 'classnames';
import { IProperty } from 'interfaces/IProperty';
import { ColorNames } from 'constants/colorNames';
import { ICompSetOrder } from 'contexts/CompSetOrderContext';
import { DragAndDrop } from 'components/DragAndDrop';

import PropertyCardListItem from './PropertyCardListItem';
import styles from './PropertyCardList.module.scss';

interface Props {
  properties: IProperty[];
  noBorder: boolean;
  itemsTopRightButtonClassName: string;
  onItemTopRightButtonClick: (property: IProperty) => void;

  cardBackgroundColor?: ColorNames;
  isDisabled?: boolean;
  wrapperClassName?: string;
  isDraggable?: boolean;
  isPropertyFeatured?: boolean;
  hasFeature?: boolean;
  featuredProperty?: boolean;
  saveContextOrderType?: keyof ICompSetOrder;
  onClickFeatured?: (id: number) => void;
}

interface IPropertyWithId extends IProperty {
  id: number;
}
const PropertyCardList: React.FC<Props> = props => {
  const draggableItems = (
    <DragAndDrop
      items={props.properties as IPropertyWithId[]}
      saveContextOrderType={props.saveContextOrderType}
      renderItem={(property, index) => {
        const propertyId = Number(property?.id);
        return (
          <PropertyCardListItem
            key={index}
            onTopRightButtonClick={() =>
              props.onItemTopRightButtonClick?.(property)
            }
            topRightButtonClassName={props.itemsTopRightButtonClassName}
            property={property}
            noBorder={props.noBorder}
            cardBackgroundColor={props.cardBackgroundColor}
            isDisabled={props.isDisabled}
            isPropertyFeatured={props.isPropertyFeatured}
            onTopLeftButtonClick={() => props.onClickFeatured?.(propertyId)}
            hasFeature={props.hasFeature}
          />
        );
      }}
    />
  );

  const propertyCardList = props.properties.map((property, index) => (
    <PropertyCardListItem
      key={index}
      onTopRightButtonClick={() => props.onItemTopRightButtonClick?.(property)}
      topRightButtonClassName={props.itemsTopRightButtonClassName}
      property={property}
      noBorder={props.noBorder}
      cardBackgroundColor={props.cardBackgroundColor}
      isDisabled={props.isDisabled}
    />
  ));
  return props.isDraggable ? (
    draggableItems
  ) : (
    <div className={classnames(styles.container, props.wrapperClassName)}>
      {propertyCardList}
    </div>
  );
};

export default PropertyCardList;
